const actions = [
  {
      title: 'Make your goal specific.',
      text: 'Be clear on what it is that you want to achieve. Ask yourself what is it that you want to accomplish? When and where will you do so? Who and what is involved? Write down your goal and keep it somewhere visible like the fridge (E.g. “On Sunday evenings my family and I will create a meal plan each week including breakfast, lunch, dinner and snacks”).',
  },
  {
      title: 'Make your goal measurable.',
      text: 'Having measurable goals will help you keep track your progress and stay motivated. Ask yourself how often will you work on your goal? How will you know when you\'ve completed it?',
    },
    {
        title: 'Make your goal achievable.',
        text: 'For your goal to be successful it needs to be realistic and attainable. Is your goal achievable with the resources you have? Consider your health, time, finances and skills. Think about breaking down your goals. What is your long-term goal? What smaller goals could you set yourself on your way to your bigger, long-term, goal?',
    },
    {
        title: 'Make your goal relevant.',
        text: 'You\'re more likely to reach goals if they mean something to you. Ask yourself why is making this change important to you now?',
    },
    {
        title: 'Make your goal time-bound.',
        text: 'When would you like to achieve your goal by? Setting a date is important for knowing whether you\'ve reached your goal or not. Make sure you give yourself a reasonable time limit and consider different timeframes for smaller steps.',
    }
];

const tip = 'Set a goal that\'s specific and meaningful to you. Writing down your goal will make it more likely that you\'ll achieve it. Keep a note of your goal somewhere that you\'ll see it every day, for example on a keyring, so that it says in your mind!';

// eslint-disable-next-line import/no-anonymous-default-export
export default { actions, tip };
